<div class="toast-container">
  <img class="icon" src="assets/images/toast-icon.svg" alt="icon" />
  <div class="toast-message">
    <div class="title">{{ data.message }}</div>
    <div class="date">{{ today | date : 'dd/MM/yyyy' }}</div>
  </div>
  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
